import StageDescription from './StageDescription'
import StageItemDescription from './StageItemDescription'
import CharaDescription from './CharaDescription'

export const StageDescription2Object = (stage: StageDescription) => {
  return JSON.parse(JSON.stringify(stage))
}

export const Object2StageDescription = (obj: any) => {
  const charaData = obj.chara
  const itemsData = obj.items
  const chara = new CharaDescription(charaData)
  const items = itemsData.map((itemData: any) => {
    return new StageItemDescription(
      itemData.id,
      itemData.type,
      itemData.acceName,
      itemData.x,
      itemData.y,
      itemData.angle,
      itemData.scale,
      itemData.order
    )
  })
  return new StageDescription(chara, items, obj.thumbData)
}
